import PropTypes from "prop-types";
import { Box, Stack, Typography } from "@mui/material";
import { Check } from "lucide-react";

import { Dialog, DialogContent } from "@/components/Dialog";
import { Button } from "@/components/Button";
import { brand } from "@/theme/theme";
import { SETUP_ITEMS } from "./seoSetupUtils";

// Shown right after creating a client, before the SEO setup stepper.
export function ClientCreatedModal({ open, client, onStart, onSkip }) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onSkip()} disableBackdropClose maxWidth="xs" fullWidth>
      <DialogContent sx={{ px: { xs: 2.5, sm: 4 }, pt: 4, pb: 3 }}>
        <Stack alignItems="center" textAlign="center" spacing={1}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              background: brand.gradientDiagonal,
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 1,
            }}
          >
            <Check size={28} strokeWidth={3} />
          </Box>
          <Typography component="h2" sx={{ fontSize: "1.25rem", fontWeight: 700, color: brand.ink }}>
            ¡Cliente creado con éxito!
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {client?.name ? (
              <>
                <Box component="strong" sx={{ color: brand.ink }}>{client.name}</Box> ya está dado de alta.
              </>
            ) : (
              "Tu nuevo cliente ya está dado de alta."
            )}
          </Typography>
        </Stack>

        <Box sx={{ mt: 3, p: 2, borderRadius: "12px", border: "1px solid #E8ECF2", backgroundColor: "#FAFBFC" }}>
          <Typography sx={{ fontSize: "0.875rem", fontWeight: 600, color: brand.ink }}>
            Siguiente paso: configura su seguimiento SEO y GEO
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 1.5 }}>
            En unos minutos tendrás listo el seguimiento de posiciones y visibilidad:
          </Typography>
          <Stack spacing={1}>
            {SETUP_ITEMS.map(({ icon: Icon, text }) => (
              <Stack key={text} direction="row" alignItems="center" spacing={1.25}>
                <Box sx={{ color: brand.pink, display: "flex" }}>
                  <Icon size={16} />
                </Box>
                <Typography variant="body2" sx={{ color: brand.ink }}>
                  {text}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Box>

        <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 1.5, textAlign: "center", fontWeight: 600 }}>
          Si lo omites, podrás hacerlo más tarde desde la ficha del cliente, en la sección «Activos Digitales».
        </Typography>

        <Stack direction={{ xs: "column-reverse", sm: "row" }} spacing={1} sx={{ mt: 2.5 }}>
          <Button variant="outline" onClick={onSkip} sx={{ flex: 1 }}>
            Omitir por ahora
          </Button>
          <Button onClick={onStart} sx={{ flex: 1 }}>
            Empezar configuración
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

ClientCreatedModal.propTypes = {
  open: PropTypes.bool.isRequired,
  client: PropTypes.shape({ name: PropTypes.string }),
  onStart: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
};

export default ClientCreatedModal;
